import React, { useEffect, useMemo, useState } from "react";
import ClubConfirmationPage from "./ClubConfirmationPage";
import Club from "../../api/models/Club";
import { useClubs } from "../../GlobalContext/selectedClubsContext";
import { Link, useLocation, useParams } from "react-router-dom";
import Header from "../Header";
import { routes } from "../../routes/routes";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import { usePromoterSelectedGroup } from "../../hooks/usePromoterSelectedGroup";
import { usePromoterMissingClubs } from "../../hooks/usePromoterMissingClubs";
import { defaultImgs } from "../../utils/defaultImages";
import { handleClubImgError } from "../../handleImgError";

const AddMissingClub: React.FC = () => {
  const { selectedClubs, addClub, removeClub, setActiveGroup } = useClubs();
  const [selectedClub, setSelectedClub] = useState<Club | null>(null);
  const { city, groupId } = useParams();
  const location = useLocation();
  const { selectedGroup, requestState } = usePromoterSelectedGroup(groupId);
  const { missingClubs, requestState: missingClubsRequestState } =
    usePromoterMissingClubs(selectedGroup);
  const routeState = location.state as { returnTo?: string } | null;
  const resolvedCity = selectedGroup?.party.city ?? city;
  const returnTo = routeState?.returnTo ?? (
    resolvedCity && groupId
      ? routes.PromGroupDetailPage(resolvedCity, groupId)
      : routes.PromotersMode
  );

  const makeOfferUrl = resolvedCity && groupId
    ? routes.MakeOffer(resolvedCity, groupId)
    : returnTo;

  useEffect(() => {
    setActiveGroup(groupId);
  }, [groupId, setActiveGroup]);

  const handleSelectClub = (club: Club) => {
    const isClubSelected = selectedClubs.some(
      (selectedClub) => selectedClub.id === club.id
    );

    if (isClubSelected) {
      removeClub(club.id);
      return;
    }

    setSelectedClub(club);
  };

  const handleConfirm = () => {
    if (selectedClub) {
      addClub(selectedClub);
    }
    setSelectedClub(null);
  };

  const handleCancel = () => {
    setSelectedClub(null);
  };

  const clubData: Club[] = useMemo(
    () =>
      missingClubs.map((club) => {
        const clubName = club.DisplayName;
        return {
          id: club.ClubId,
          name: clubName,
          img: club.PictureUrl ?? defaultImgs.ClubImg,
        };
      }),
    [missingClubs]
  );

  const websiteRootUrl = process.env.REACT_APP_BE_URL?.split("/app-apis")[0];
  const requestNewClubUrl = `${websiteRootUrl}/Venue`;
  return (
    <div>
      {selectedClub && (
        <ClubConfirmationPage
          selectedClub={selectedClub}
          handleConfirm={handleConfirm}
          handleCancel={handleCancel}
          makeOfferUrl={makeOfferUrl}
          returnTo={returnTo}
          partyDate={selectedGroup?.party.partyDate}
        />
      )}
      {!selectedClub && (
        <>
          <Header />
          <div className="centerGroup">
            <div className="desktopUI">
              <div className="row userProfile_Header">
                <Breadcrumbs />
              </div>
              <div className="yellowTxt container vh-100 mt-2">
                <h4 className="text-center mt-2 mb-5">Is it one of these?</h4>
                {requestState === "loading" || requestState === "idle" || missingClubsRequestState === "loading" || missingClubsRequestState === "idle" ? (
                  <p className="text-center">Loading clubs...</p>
                ) : requestState === "error" || !selectedGroup ? (
                  <p className="text-center">Group not found.</p>
                ) : (
                  <div>
                    {clubData
                      .map((club) => (
                        <div className="clubCon" key={club.id}>
                          <div className="form-check m-3 align-items-center col d-flex">
                            <input
                              className="form-check-input checkC shadow-none"
                              type="checkbox"
                              checked={selectedClubs.some(
                                (selectedClub) => selectedClub.id === club.id
                              )}
                              onChange={() => handleSelectClub(club)}
                            />
                            <img src={club.img || defaultImgs.ClubImg} 
                                className="clubImg" 
                                alt={club.name}
                                onError={(event) => handleClubImgError(event)} />
                            <div className="align-content-center col d-flex">
                              <label className="yellowTxt col text-left">{club.name}</label>
                            </div>
                          </div>
                        </div>
                      ))}
                    {clubData.length === 0 && (
                      <p className="text-center">No missing clubs found for this city and date.</p>
                    )}
                  </div>
                )}
                <div className="  mb-5 mt-3  yellowTxt container">
                  <Link
                    to={requestNewClubUrl}
                    className="link btns btnMO justify-content-center mb-02 d-flex mt-3 align-content-center  col-12 mt-2 mb-2"
                    target="_blank"
                  >
                    Request new Club
                  </Link>
                  <Link
                    to={makeOfferUrl}
                    state={{ returnTo, preserveOfferState: true }}
                    className="link btns btnMO justify-content-center mb-2 d-flex mt-3 align-content-center  col-12 mt-2 mb-2"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AddMissingClub;
